import { withStyles } from "@mui/styles";
import { injectIntl } from "react-intl";
import { Styles } from '../../../../styles/material-styles';
import { Paper, TableBody, TableHead, TableRow, Typography } from "@mui/material";
import * as LLMKeyWordService from "../../../../services/llmkeyword.service.js";
import { heading, StyledIconButton, StyledTable, StyledTableBodyCell, StyledTableCell, StyledTableContainer } from "./styles";
import { Delete } from "@mui/icons-material";
import { memo, useEffect, useState } from "react";
import { NotificationVariant } from "src/utils/enums/notification-variants.enum";

const LLMKeyWordList = (props) => {
    const { intl, data, onShowNotification, onLoading } = props;

    const [rows, setRows] = useState([]);

    const handleDeleteKeyWord = async (keyWord) => {
        onLoading(true);

        try {
            if (keyWord?.id) {
                const response = await LLMKeyWordService.deleteById(keyWord?.id);

                if (response?.success === true) {
                    onShowNotification("Deletado com sucesso.");
                    setRows(prev => {
                        return prev.filter(kw => kw?.id !== keyWord.id)
                    });
                } else {
                    onShowNotification("Não foi possível remover a palavra chave.", NotificationVariant.ERROR);
                }
            }   
        } catch (err) {
            onShowNotification("Não foi possível remover a palavra chave.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    useEffect(() => {
        setRows(data ?? []);
    }, [data]);

    return (
        rows?.length > 0 && (
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>{intl.formatMessage({ id: "event" })}</StyledTableCell>
                            <StyledTableCell>{intl.formatMessage({ id: "keywords" })}</StyledTableCell>
                            <StyledTableCell>{intl.formatMessage({ id: "delete" })}</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows?.map(kw => (
                            <TableRow key={kw.id}>
                                <StyledTableBodyCell>
                                    {kw?.eventname}
                                </StyledTableBodyCell>

                                <StyledTableBodyCell>
                                    {kw?.keyword}
                                </StyledTableBodyCell>
                                
                                <StyledTableBodyCell>
                                    <StyledIconButton delete onClick={() => handleDeleteKeyWord(kw)}>
                                        <Delete />
                                    </StyledIconButton>
                                </StyledTableBodyCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        )
    )
}

export default memo(
    injectIntl(withStyles(Styles)(LLMKeyWordList)),
    (prevProps, nextProps) => JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data)
);